"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeExcessWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var Types_1 = require("../../../Types");
var core_1 = require("@athena-portal/core");
var reactstrap_1 = require("reactstrap");
var commonFunctions_1 = require("../../../commonFunctions");
var journey_services_1 = require("@athena-portal/journey-services");
var services_1 = require("@falcon/services");
var HomeExcessWidget = exports.HomeExcessWidget = /** @class */ (function (_super) {
    __extends(HomeExcessWidget, _super);
    function HomeExcessWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.renderWarningModal = function () {
            var closeBtn = React.createElement("button", { className: "btn-close", onClick: _this.toggleWarningPopUp });
            return (React.createElement(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: _this.state.showWaringPopup, toggle: _this.toggleWarningPopUp },
                React.createElement(reactstrap_1.ModalHeader, { toggle: _this.toggleWarningPopUp, close: closeBtn },
                    React.createElement("div", { className: "d-flex" },
                        React.createElement("img", { className: "d-block mr-3 mb-1 info-icon-selected", src: "/img/Flow-info-selected.svg", alt: "Attention icon" }),
                        React.createElement("div", { className: "text-blue-2 font-weight-medium fs-20" }, "High excess"))),
                React.createElement(reactstrap_1.ModalBody, { className: "pt-0 overflow-auto" },
                    React.createElement("div", { className: "mb-3" },
                        React.createElement("p", { className: "m-0" }, "Please note: if you choose a higher excess, some cover (such as \u2018freezer contents\u2019) may no longer provide benefit as the excess you\u2019d pay would exceed the value of your claim."))),
                React.createElement(reactstrap_1.ModalFooter, { className: "d-flex modal-footer" },
                    React.createElement("button", { type: "button", className: "btn btn-primary btn-add width-md-250 mb-1", onClick: _this.toggleWarningPopUp }, "Ok, I understand"))));
        };
        _this.handleSelectOnChangeEvent = function (event) {
            var allOthersClaim = parseInt(event.target.value, 10);
            if (allOthersClaim === 500) {
                _this.setState({
                    showWaringPopup: true
                });
            }
            _this.setState({
                allOthersClaim: allOthersClaim
            });
            journey_services_1.ObjectManipulator.setField("annualHomeExcesses.allOtherClaims", _this.props.interaction, allOthersClaim);
            _this.executeNativeEvent(event);
        };
        _this.state = {
            showPopup: false,
            allOthersClaim: _this.props.interaction.annualHomeExcesses.allOtherClaims,
            showWaringPopup: false
        };
        _this.togglePopUp = _this.togglePopUp.bind(_this);
        _this.toggleWarningPopUp = _this.toggleWarningPopUp.bind(_this);
        return _this;
    }
    HomeExcessWidget.prototype.render = function () {
        var allOthersClaim = this.state.allOthersClaim;
        var isDisabled = (this.props.interaction.process === services_1.INTERACTION_PROCESS_MTA_CHANGE_ADDRESS) || (this.props.interaction.process === services_1.INTERACTION_PROCESS_SUPPORT_PORTAL_MTA_CHANGE_ADDRESS);
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "quote-excess-header" }),
            React.createElement("div", { className: "quote-excess-content" },
                React.createElement("h1", { className: "text-blue-2 mt-3" }, "Excess"),
                React.createElement("div", { className: "panel text-center" },
                    this.renderWarningModal(),
                    React.createElement("h2", { className: "inner-content text-center font-family-display font-weight-medium mt-0 mb-2 clearfix" },
                        React.createElement("div", { className: "mx-5" }, "Excess")),
                    React.createElement("p", { className: "font-weight-bold" }, "These are the amounts you must pay towards a claim."),
                    React.createElement("p", { className: "excess-warning" },
                        "Please note: if you choose a higher excess, some cover (such as \u2018money\u2019) may no longer provide benefit as the excess you\u2019d pay would exceed the value of your claim.",
                        React.createElement("br", null),
                        "For example, under our Bronze product we offer  up to \u00A3250 for money in the home, however if you chose an excess of \u00A3500 your excess would be more than the limit provided."),
                    React.createElement("table", { className: "payment-choice-table excess mb-3" },
                        React.createElement("tr", { className: "payment-choice-row-grey" },
                            React.createElement("td", null,
                                "Subsidence, heave or landslip",
                                services_1.resourcesHelper.THEME === "Allianz" ? ": " : ""),
                            React.createElement("td", null,
                                React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.annualHomeExcesses.subsidence)))),
                        React.createElement("tr", { className: "payment-choice-row-white" },
                            React.createElement("td", null,
                                "Escape of water",
                                services_1.resourcesHelper.THEME === "Allianz" ? ": " : ""),
                            React.createElement("td", null,
                                React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.annualHomeExcesses.escapeOfWater)))),
                        React.createElement("tr", { className: "payment-choice-row-grey" },
                            React.createElement("td", null,
                                "Flood",
                                services_1.resourcesHelper.THEME === "Allianz" ? ": " : ""),
                            React.createElement("td", null,
                                React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.annualHomeExcesses.flood)))),
                        React.createElement("tr", { className: "payment-choice-row-white" },
                            React.createElement("td", null,
                                "All other claims",
                                services_1.resourcesHelper.THEME === "Allianz" ? ": " : ""),
                            React.createElement("td", null,
                                React.createElement("div", { className: "input-group width-maxcontent" },
                                    React.createElement("select", { id: this.props.question.name, className: "form-control voluntary-excess-picker__dropdown", onChange: this.handleSelectOnChangeEvent, onFocus: this.executeNativeEvent, onClick: this.executeNativeEvent, onDoubleClick: this.executeNativeEvent, disabled: isDisabled }, this.renderOptionsList(allOthersClaim))))))))));
    };
    HomeExcessWidget.prototype.renderOptionsList = function (allOthersClaim) {
        var options = [];
        for (var i = 150; i <= 500; i = i + 50) {
            options.push(React.createElement("option", { key: i, selected: allOthersClaim === i, value: i }, (0, commonFunctions_1.getAmountToDisplay)(i)));
        }
        return options;
    };
    HomeExcessWidget.prototype.togglePopUp = function () {
        this.setState(function (state) { return ({
            showPopup: !state.showPopup
        }); });
    };
    HomeExcessWidget.prototype.toggleWarningPopUp = function () {
        this.setState(function (state) { return ({
            showWaringPopup: !state.showWaringPopup
        }); });
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], HomeExcessWidget.prototype, "changelogRecorder", void 0);
    return HomeExcessWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=HomeExcessWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/HomeExcessWidget.js
// module id = 3686
// module chunks = 0